<template>

<com-item name="player.groups" :has-more="data.total > 5" v-on:more="onMoreClick" :size="size" :is-list="true" :loading="loading" :is-empty="!active" title="Frequent Groups">

	<template v-slot:about>

		<p>Most common group combinations with {{ playername }}.</p>

	</template>

	<template v-slot:stats>

		<app-users :item="item" v-for="(item, index) in data.groups" :max="5" count-text="play" :key="index" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		playername: function() {

			var name = this.player.name
			return name.split(' ')[0]

		},

		player: function() {

			return this.$store.getters['page/insights/player/player']

		},

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/player/groups']

		},

		active: function() {

			return this.data.groups.length && !this.loading

		}

	},

	methods: {

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayerGroups'
			})
		
		}

	}

}

</script>

<style scoped>

</style>